import { Component, OnDestroy, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Data, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { Subscription } from "rxjs";
import { environment } from "src/environments/environment";
import { IonicModule } from "@ionic/angular";

@Component({
    selector: "app-partner-offer",
    templateUrl: "./partner-offer.component.html",
    styleUrls: ["./partner-offer.component.scss"],
    standalone: true,
    imports: [IonicModule],
})
export class PartnerOfferComponent implements OnInit, OnDestroy {
  iframeLink: Data;
  public condition: boolean;
  private GlobalPartnerOffersSubscription: Subscription;
  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private sanitizer: DomSanitizer,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route?.queryParams?.subscribe(
      (params) => {
        if (params && params?.p) {
          this.checkPartnerOfferType(params?.p);
        } else {
          this.navigateToSyndicate();
        }
      },
      (error) => {
        return error;
      }
    );
  }

  checkPartnerOfferType(partnerOfferName: string): void {
    const partnerOffers = [
      {
        name: "sovendus",
        iframe_url: `${environment.baseURL}/sovendus-offers`,
      },
    ];
    const existingPartnerPage = partnerOffers.find((val) => val?.name === partnerOfferName);
    if (existingPartnerPage) {
      this.existingPartnerOfferUrl(existingPartnerPage);
    } else {
      this.getPartnerOfferUrl(partnerOfferName);
    }
  }

  existingPartnerOfferUrl(partnerOffer: Data): void {
    this.condition = true;
    this.iframeLink = this.sanitizer?.bypassSecurityTrustResourceUrl(partnerOffer?.iframe_url);
  }

  getPartnerOfferUrl(partnerOffer: string): void {
    this.GlobalPartnerOffersSubscription = this.authService?.getGlobalPartnerOffers(partnerOffer).subscribe(
      (res) => {
        if (res && res?.status) {
          this.condition = true;
          this.iframeLink = this.sanitizer?.bypassSecurityTrustResourceUrl(res?.iframe_url);
        } else {
          this.navigateToSyndicate();
        }
      },
      (err) => {
        this.navigateToSyndicate();
        return err;
      }
    );
  }

  navigateToSyndicate() {
    this.router.navigateByUrl("mainTabs/tabs/syndicate").catch((error) => {
      return error;
    });
  }

  ngOnDestroy(): void {
    this.GlobalPartnerOffersSubscription?.unsubscribe();
  }
}
